import { createUpperCaseNormalizer, trimNormalizer } from '../../../../_common/core/validation'

const hasIntentionalCasing = value => /[a-z][A-Z]/.test(value) || /\b[A-Z]{2,}\b/.test(value)

/**
 * Normalizes the value once (on creation), then preserves deliberate casing edits.
 *
 * State shape:
 * - didAutoNormalize: boolean
 * - disableAutoNormalize: boolean
 */
export const createOneTimeCasingBlurNormalizer =
  ({ isEditing, state, normalize }) =>
  value => {
    const trimmed = trimNormalizer(value)

    if (!trimmed) {
      state.didAutoNormalize = false
      state.disableAutoNormalize = false
      return trimmed
    }

    if (isEditing || state.disableAutoNormalize) return trimmed

    const normalized = normalize(trimmed)

    if (!state.didAutoNormalize) {
      state.didAutoNormalize = true
      return normalized
    }

    if (trimmed !== normalized && hasIntentionalCasing(trimmed)) {
      state.disableAutoNormalize = true
      return trimmed
    }

    return normalized
  }

export const createTicketTypeNameOnBlurNormalizer = ({ isEditing, state }) => {
  const displayNameReg = new RegExp(/([^()\[\]\s-]+)/g)
  const displayNameOptions = ['ga', 'rsvp', 'vip', 'bf', 'nye', 'aaa', 'byob', 'byo', 'rv', 'abc']

  return createOneTimeCasingBlurNormalizer({
    isEditing,
    state,
    normalize: createUpperCaseNormalizer(displayNameReg, displayNameOptions),
  })
}
